"use strict";
import { tns } from "../../../node_modules/tiny-slider/src/tiny-slider";

export default function () {
    const valid = document.querySelector(".o-clients__list");
    if (valid) {
        const slider = tns({
            container: ".o-clients__list",
            items: 2.3,
            slideBy: 1,
            controls: false,
            nav: false,
            gutter: 12,
            loop: true,
            touch: true,
            mouseDrag: true,
            responsive: {
                1024: {
                    items: 5,
                },
            },
        });

        const arrowLeft = document.querySelector(".o-clients .arrows-left");
        arrowLeft.addEventListener("click", () => {
            slider.goTo("prev");
        });
        const arrowRight = document.querySelector(".o-clients .arrows-right");
        arrowRight.addEventListener("click", () => {
            slider.goTo("next");
        });
    }
}
